module.exports = __webpack_public_path__ + "static/recipe_screen-ff60450948bfba86d2a5663956589f53.png";